import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Alert } from '@/components/Alert';
import { Button } from '@/components/Button';
import { api } from '@/lib/api';
import { usePreferenceScope } from '@/hooks/useStoredPreference';

export interface LegacyOpportunityRedirectProps { study?: boolean; }
export const LegacyOpportunityRedirect = ({ study = false }: LegacyOpportunityRedirectProps) => {
    const { t } = useTranslation('global');
    const location = useLocation();
    const [params] = useSearchParams();
    const scope = usePreferenceScope();
    const studyId = study ? Number(params.get('record')) : 0;
    const query = useQuery({ queryKey: ['opportunities', scope, 'legacy-study', studyId], enabled: studyId > 0, retry: false,
        queryFn: async ({ signal }) => (await api.get<{ data: { id: number } }>(`/opportunities/legacy-study/${studyId}`, { signal })).data.data });
    if(studyId && query.isPending){
        return <p role="status">{t('opportunities.loading')}</p>;
    }
    if(studyId && query.isError){
        return <Alert variant="error"><p>{t('opportunities.load_error')}</p><Button variant="outline" onClick={() => { void query.refetch(); }}>{t('opportunities.retry')}</Button></Alert>;
    }
    const next = new URLSearchParams(params);
    next.set('view', 'list');
    const last = location.pathname.split('/').filter(Boolean).at(-1) ?? '';
    const states: Record<string, string> = { decision_pending: 'decision_pending', study_pending: 'in_study', accepted: 'in_study', historical: 'in_study', in_study: 'in_study',
        rejected: 'discarded', not_submitted: 'discarded', not_awarded: 'discarded', submitted: 'submitted', awarded: 'awarded' };
    if(states[last]){
        next.set('status', states[last]);
    }
    if(study && !states[last] && last !== 'all'){
        next.set('status', 'in_study');
    }
    if(query.data){
        next.set('record', String(query.data.id));
    }
    return <Navigate to={`/tenders?${next.toString()}`} replace />;
};
